import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/start'
import actions from '../actions/start'
import orchestratorActions from '../actions/orchestrator'
import addressActions from '../actions/address'

class Container extends React.Component {

  constructor(props) {
    super(props)

    props.createRent()
    props.fetchAddresses()
    props.nextStepFromStart()
  }

  render() {
    return <Component {...this.props}/>
  }

  static propTypes = {
    createRent: PropTypes.func.isRequired,
    fetchAddresses: PropTypes.func.isRequired,
    nextStepFromStart: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.rent.start
  return {
    isLoading: data.get('loading').size > 0,
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createRent: () => {
      return dispatch(actions.createRent())
        // .then(rentId => dispatch(actions.assignItem(rentId)))
        .catch(() => {})
    },
    fetchAddresses: () => dispatch(addressActions.fetch()),
    nextStepFromStart: () => dispatch(orchestratorActions.nextStepFromStart()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/rent/containers/start.js